import uuid from 'node-uuid';
import { isBatchEligible } from '../payments/selectors';
import { isBatchEligible as isChapsBatchEligible } from '../chaps/selectors';
import { TYPE_CHAPS } from '../../config';

export const UPDATE_BATCH_NAME = 'UPDATE_BATCH_NAME';
export const UPDATE_BATCH_ID = 'UPDATE_BATCH_ID';
export const TOGGLE_BATCH = 'TOGGLE_BATCH';
export const INITIALISE_BATCH = 'INITIALISE_BATCH';
export const SET_BATCH_AUTHORISERS = 'SET_BATCH_AUTHORISERS';
export const UPDATE_BATCH_TYPE = 'UPDATE_BATCH_TYPE';

export const updateBatchName = ({ name }) => ({
	type: UPDATE_BATCH_NAME,
	name,
});

export const updateBatchId = (id) => ({
	type: UPDATE_BATCH_ID,
	id,
});

export const toggleBatch = (isBatch) => ({
	type: TOGGLE_BATCH,
	isBatch,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const initialiseBatch = (batch) => ({
	type: INITIALISE_BATCH,
	batch: {
		...batch,
		context_id: batch.id,
		id: uuid.v1(),
	},
	meta: {
		allowedDuringApiCall: true,
	},
});

export const setBatchPaymentAuthorisers = (authorisers) => ({
	type: SET_BATCH_AUTHORISERS,
	authorisers,
});

export const updateBatchType = ({ batchType }) => ({
	type: UPDATE_BATCH_TYPE,
	batchType,
});

export const toggleFasterPaymentBatch = (state, dispatch) => {
	if (isBatchEligible(state)) return dispatch(toggleBatch(true));
	return dispatch(toggleBatch(false));
};

export const toggleChapsBatch = (state, dispatch) => {
	if (isChapsBatchEligible(state)) return dispatch(toggleBatch(true));
	return dispatch(toggleBatch(false));
};

export const toggleBatchIfEligible = (paymentType) => (dispatch, getState) => {
	const state = getState();
	switch (paymentType) {
		case TYPE_CHAPS:
			return toggleChapsBatch(state, dispatch);
		default:
			return toggleFasterPaymentBatch(state, dispatch);
	}
};
